export default {
	loading: false,
	incoterms: [],
	errors: {
		id: '',
		name: false,
		description: false
	},
	postalPlaces: [],
};